import { useTu } from "@src/appV2/i18n/useTu";
import { Stack } from "@mui/material";

import { SearchInput } from "../../components/SearchInput/SearchInput";
import { ProfessionalList } from "../../DailyView/components/InviteDrawer/ProfessionalList";
import {
  type InviteFlowStatus,
  type Professional,
} from "../../DailyView/components/InviteDrawer/types";
import { LabeledField } from "./LabeledField";

interface ProfessionalSearchFieldProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  isSearching: boolean;
  allProfessionals: Professional[];
  starredProfessionals: Professional[];
  recentProfessionals: Professional[];
  selectedProfessional: Professional | undefined;
  status: InviteFlowStatus;
  onSelectProfessional: (professional: Professional) => void;
}

export function ProfessionalSearchField(props: ProfessionalSearchFieldProps) {
  const { tu } = useTu("schedule");
  const {
    searchQuery,
    onSearchChange,
    isSearching,
    allProfessionals,
    starredProfessionals,
    recentProfessionals,
    selectedProfessional,
    status,
    onSelectProfessional,
  } = props;

  return (
    <LabeledField label={tu("Professional")}>
      <Stack spacing={2} sx={{ minWidth: 0 }}>
        <SearchInput
          isLoading={isSearching}
          placeholder={tu("Search professionals...")}
          value={searchQuery}
          onChange={onSearchChange}
        />
        <ProfessionalList
          allProfessionals={allProfessionals}
          isSearching={isSearching}
          recentProfessionals={recentProfessionals}
          searchQuery={searchQuery}
          selectedProfessional={selectedProfessional}
          starredProfessionals={starredProfessionals}
          status={status}
          onSelectProfessional={onSelectProfessional}
        />
      </Stack>
    </LabeledField>
  );
}
